module.exports = __webpack_public_path__ + "img/telegram.b5a31e65.svg";